import { useLayoutEffect, useRef } from 'react';
import { useTableDispatch } from '../../redux/reduxHooks';
import { clearSelection } from '../../selection/redux/selectionSlice';
import { resetToDefaultVisibility } from '../../virtualization/redux/visibleCellsSlice';

const areRowIdsEqual = (currentRows, prevRows) => prevRows && prevRows.length === currentRows.length && prevRows.every((rowId, index) => currentRows[index] === rowId);

export const useResetTableState = ({
  rowIds,
  tableContainerRef,
  resetObserver
}) => {
  const prevRowIdsRef = useRef(null);
  const dispatch = useTableDispatch();
  useLayoutEffect(() => {
    if (areRowIdsEqual(rowIds, prevRowIdsRef.current)) {
      return;
    }

    prevRowIdsRef.current = rowIds; // Clear selection state

    dispatch(clearSelection()); // Reset to the default visible rows/cols

    dispatch(resetToDefaultVisibility()); // Teardown and re-create the observer so that we
    // check visiblity once more

    resetObserver(); // Scroll the table to the top if possible

    if (tableContainerRef.current) {
      tableContainerRef.current.scrollTop = 0;
    }
  }, [dispatch, resetObserver, rowIds, tableContainerRef]);
};